import { createSelector } from 'reselect'

import { PARTICIPANTS_ALL_CATEGORY } from 'containers/AwarenessCenter/constants'

const _ = require('lodash')

const selectError = (state) => state.awarenessCenter.autonomousScheduler.error
const selectLoader = (state) => state.awarenessCenter.autonomousScheduler.loader
const selectSubmitLoader = (state) => state.awarenessCenter.autonomousScheduler.submitLoader
const selectParticipants = (state) => state.awarenessCenter.autonomousScheduler.participants
const selectMonths = (state) => state.awarenessCenter.autonomousScheduler.months
const selectMembers = (state) => state.awarenessCenter.autonomousScheduler.members
const selectCandidates = (state) => state.awarenessCenter.autonomousScheduler.candidates
const selectParticipantsInfoToIncludeMsp = (state) =>
  state.awarenessCenter.autonomousScheduler.participantsInfoToIncludeMsp
const selectParticipantsInfoToInclude = (state) =>
  state.awarenessCenter.autonomousScheduler.participantsInfoToInclude
const selectParticipantsInfoLoader = (state) =>
  state.awarenessCenter.autonomousScheduler.participantsInfoLoader
const selectParticipantsNumbers = (state) =>
  state.awarenessCenter.autonomousScheduler.participantsNumbers
const selectConflictedCompanies = (state) =>
  state.awarenessCenter.autonomousScheduler.conflictedCompanies

const selectParticipantsInfoToExclude = createSelector(
  selectParticipants,
  selectParticipantsInfoToInclude,
  (participants, participantsInfoToInclude) => {
    const selectedParticipants = participants.included
    const participantsToExclude = _.cloneDeep(participantsInfoToInclude) // deep-clone to not change original
    // options from exclude
    const categoriesToAvoid = [PARTICIPANTS_ALL_CATEGORY]
    categoriesToAvoid.forEach((i) => delete participantsToExclude[i])
    // iterate through included participants
    Object.keys(selectedParticipants)
      .filter((i) => !categoriesToAvoid.includes(i))
      .map((category) => {
        selectedParticipants[category].map((field) => {
          if (Array.isArray(participantsToExclude[category])) {
            // children are in array
            participantsToExclude[category] = participantsToExclude[category].filter(
              (a) => a !== field
            )
          } else if (!Array.isArray(participantsToExclude) && participantsToExclude[category]) {
            delete participantsToExclude[category][field]
          }
        })
      })

    return participantsToExclude
  }
)

export {
  selectError,
  selectLoader,
  selectSubmitLoader,
  selectParticipants,
  selectParticipantsInfoToInclude,
  selectParticipantsInfoToExclude,
  selectMonths,
  selectMembers,
  selectCandidates,
  selectParticipantsNumbers,
  selectParticipantsInfoToIncludeMsp,
  selectConflictedCompanies,
  selectParticipantsInfoLoader,
}
